type ProductDetailsTerpenesContentProps = {
	characteristicName: string;
	characteristicValue: string[];
};

export function ProductDetailsTerpenesContent({
	characteristicName,
	characteristicValue,
}: ProductDetailsTerpenesContentProps) {
	return (
		<div>
			<p className="text-body-sm-emphasis first-letter:uppercase text-gray-700">
				{characteristicName}
			</p>

			<p className="text-body-sm text-gray-500">
				{characteristicValue.join(", ")}
			</p>
		</div>
	);
}
